import { create } from 'zustand';
import { IFinancialPosition } from '../../sp-types/financialPositionType';

interface IFinancialPositionStore {
  financialPositions: IFinancialPosition[];
  isFinancialPositionLoading: boolean;
  setIsFinancialPositionLoading: (_value: boolean) => void;
  setFinancialPositions: (_value: IFinancialPosition[]) => void;
  resetStore: () => void;
}

export const useFinancialPositionsStore = create<IFinancialPositionStore>((set) => ({
  financialPositions: [],
  isFinancialPositionLoading: true,
  setIsFinancialPositionLoading: (value: boolean) => set({ isFinancialPositionLoading: value }),
  setFinancialPositions: (financialPositions: IFinancialPosition[]) => set({ financialPositions }),

  resetStore: () => set({ financialPositions: [] }),
}));
